export default "__VITE_ASSET__Ccc_x6ol__"